import React, { useMemo } from 'react';

import DraggableMaskedImage from './DraggableMaskedImage';
import { DEFAULT_IMAGE_WIDTH, DEFAULT_IMAGE_HEIGHT, ZOOM_MULTIPLIER } from '../../constants';

import "./Image.css";

// Use require.context to dynamically require images from ./splashes
const images = require.context('./splashes', false, /\.(png|jpe?g|svg)$/);

const urlFromPath = (path) => {
  if (!path) return null;
  try {
    // Extract just the filename from the path
    const filename = path.split('/').pop();
    return images(`./${filename}`);
  } catch (e) {
    console.error('Image not found:', path, e);
    return null;
  }
};

const getMaskPosXY = (maskPosition) => {
  if (!maskPosition) return [0, 0];
  // Expecting format like '50% 25%'
  const [x, y] = maskPosition.split(' ');
  const xNum = parseFloat(x.replace('%', ''));
  const yNum = parseFloat(y.replace('%', ''));
  return [xNum || 0, yNum || 0];
}

const Image = ({ target, guessCount, size, isChallengeMode, isWin, onMaskDragEnd, onReady }) => {
  const [maskPosX, maskPosY] = getMaskPosXY(target.maskPosition);

  // Calculate mask size based on guess count to prevent exponential growth
  const maskSize = useMemo(() => {
    const baseSize = size || 100;
    return baseSize * Math.pow(ZOOM_MULTIPLIER, guessCount);
  }, [size, guessCount]);

  return (
    <div className="image-container">
      <DraggableMaskedImage
        key={`${target.champion}-${target.name}`} // Force re-render when target changes
        src={urlFromPath(target.loc)}
        width={DEFAULT_IMAGE_WIDTH}
        height={DEFAULT_IMAGE_HEIGHT}
        startingX={maskPosX}
        startingY={maskPosY}
        maskScale={maskSize}
        showFullImage={isWin}
        draggable={false}
        grayscale={isChallengeMode}
        onMaskDragEnd={onMaskDragEnd}
        onReady={onReady}
      />
    </div>
  )
};

export default Image;
